import { highLevelApi } from '@sdk/main'
import type { NotificationPayload } from '@sdk/payload.types'

export function notify(payload: NotificationPayload): Promise<void> {
  if (!payload.type) {
    payload.type = 'native'
  }

  return highLevelApi.API.request('notify', payload)
}
